module.exports = __webpack_public_path__ + "img/kep2-4.20fbcccc.jpg";